// extracted by mini-css-extract-plugin
export default {"descriptionField":"descriptionField__Cecrw"};